import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import {
  FormsFieldsState,
  ModifierTypes,
  SvgIconSizeMod
} from 'models/layout-mod.model';
import { StorageText } from 'models/value-text.model';
import { StylingService } from 'shared/services/styling.service';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss']
})
export class RadioComponent<T> implements OnInit, OnChanges {
  @Input() options!: T[];

  @Input() mainForm!: UntypedFormGroup;

  @Input() controlName!: string;

  @Input() layoutMod: ModifierTypes[] = [];

  @Input() labelKey!: string;

  @Input() valueKey = '';

  @Input() imageKey = 'img';

  @Input() markDefaultKey!: string;

  @Input() disabledKey!: string;

  @Input() allowDisabledSelection = false;

  @Input() highlight = false;

  @Input() allowDeselect = false;

  @Input() isCalcSheet = false;

  @Input() mouseoverTexts: StorageText = {};

  @Input() state?: FormsFieldsState;

  @Output() deselect = new EventEmitter<{ controlName: string; value: string; }>();

  @Output() select = new EventEmitter<{ controlName: string; value: string; }>();

  layoutModifier = '';

  svgIconSizeMod = SvgIconSizeMod;

  constructor(
    private stylingService: StylingService
  ) { }

  ngOnInit(): void {
    this.layoutModifier = this.stylingService.concatLayoutModifiers('radioBlock', this.layoutMod);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.layoutMod) {
      this.layoutModifier = this.stylingService.concatLayoutModifiers('radioBlock', this.layoutMod);
    }
  }

  onClick(event: Event, option: T): void {
    if (!this.allowDeselect) {
      return;
    }

    const value = String((option as unknown as Record<PropertyKey, unknown>)[this.valueKey]);

    if (this.mainForm.controls[this.controlName].value === value) {
      event.preventDefault();
      this.deselect.emit({ controlName: this.controlName, value });
    } else if (this.isCalcSheet) {
      event.preventDefault();
      this.select.emit({ controlName: this.controlName, value });
    }
  }
}
